import { getMediaDevices } from '@gem/call/Removable/packages/deviceInfo/deviceInfo';
import { t } from '@gem/modules/i18n';
import { popupsTasks } from '@gem/popups';

export const hasCamera = async (): Promise<boolean> => {
  const { hasCamera } = await getMediaDevices();

  if (!hasCamera) {
    popupsTasks.showAlert(t('calls_no_camera_connected'));

    return false;
  }

  return true;
};
